import superagent from 'superagent';
import uuidv4 from 'uuid/v4';

import * as types from './types';

import { userLogout, forbiddenAccess, checkVersionMisMatch } from './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getTasksStatusSuccess({ tasks }) {
  return {
    type: types.GET_TASKS_STATUS_SUCCESS,
    tasks,
  };
}

export function getTasksStatusFail() {
  return {
    type: types.GET_TASKS_STATUS_FAIL,
  };
}

export function getTasksStatus() {
  return (dispatch) => {
    request.get(`${window.Config.API_URL}/business/tasks`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getTasksStatusSuccess({ tasks: resp.body }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getTasksStatusFail());
      });
  };
}

export function getSetupInfoSuccess(setupInfo) {
  return {
    type: types.GET_SETUP_INFO_SUCCESS,
    setupInfo,
  };
}

export function getSetupInfoFail() {
  return {
    type: types.GET_SETUP_INFO_FAIL,
  };
}

export function getSetupInfo() {
  return (dispatch) => {
    request.get(`${window.Config.API_URL}/business/setupInfo`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getSetupInfoSuccess(resp.body));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getSetupInfoFail());
      });
  };
}

export function getMetricsStart(compare) {
  return {
    type: types.GET_METRICS_START,
    compare,
  };
}

export function getMetricsSuccess({ metrics, compare, brandlocation, brandOnly }) {
  return {
    type: types.GET_METRICS_SUCCESS,
    metrics,
    compare,
    brandlocation,
    brandOnly,
  };
}

export function getMetricsFail() {
  return {
    type: types.GET_METRICS_FAIL,
  };
}

export function getMetrics({ business_id, selectedDateRange, selectedUserType, compare, brandlocation, brandOnly }) {
  return (dispatch) => {
    const catchErr = (ex) => {
      console.log(ex);
      dispatch(getMetricsFail());
    };
    const ret = {};
    dispatch(getMetricsStart(compare));
    const params = Object.assign({}, {
      'business_id': business_id,
      'guest_type': selectedUserType,
      'range_type': selectedDateRange,
      ...(brandOnly && { 'average': true }),
    });
    Promise.all([
      request.post(`${window.Config.API_URL}/business/dashboard/metrics`).withCredentials().set('X-Request-ID', uuidv4())
        .send(params)
        .then((resp) => {
          dispatch(getMetricsSuccess({ metrics: resp.body, compare, brandlocation, brandOnly }));
          dispatch(checkVersionMisMatch(resp.headers));
        })
        .catch(catchErr),
      request.get(`${window.Config.API_URL}/business/outcome_visualization`).withCredentials().set('X-Request-ID', uuidv4())
        .then((resp) => {
          if (resp.statusCode === 200) {
            const data = resp.body;
            dispatch(getOutcomeVisualisationSuccess(data));
          } else {
            dispatch(getOutcomeVisualisationFail());
          }
        })
        .catch(catchErr),
    ]);
  };
}

export function getReportDataStart() {
  return {
    type: types.GET_REPORT_DATA_START,
  };
}

export function getReportDataSuccess(data) {
  return {
    type: types.GET_REPORT_DATA_SUCCESS,
    payload: data,
  };
}

export function getReportDataFail() {
  return {
    type: types.GET_REPORT_DATA_FAIL,
  };
}

export function getReportData({ business_id, selectedDateRange, selectedUserType }) {
  return (dispatch) => {
    dispatch(getReportDataStart());

    const params = {
      'business_id': business_id,
      'guest_type': selectedUserType,
      'range_type': selectedDateRange,
      'include_business_id_in_response': true,
    };
    request.get(`${window.Config.API_URL}/business/dashboard/metrics/outcomes/report`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .query(params)
      .then((resp) => {
        dispatch(getReportDataSuccess(resp.text));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getReportDataFail());
      });
  };
}

export function downloadMetricsReport({ month, year, newUsersOnly, type }) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const params = Object.assign({}, {
      month,
      year,
      newUsersOnly,
      type,
    });

    window.open(`${window.Config.API_URL}/business/metrics/report?month=${params.month}&year=${params.year}&newUsersOnly=${params.newUsersOnly}&type=${params.type}`).withCredentials().set('X-Request-ID', uuidv4());
  };
}

export function oldgetMetricsStart(month) {
  return {
    type: types.GET_METRICS_START,
    month,
  };
}

export function oldgetMetricsSuccess({ metrics }) {
  return {
    type: types.GET_METRICS_SUCCESS,
    metrics,
  };
}

export function oldgetMetricsFail() {
  return {
    type: types.GET_METRICS_FAIL,
  };
}

export function oldgetMetrics({ month, year, newUsersOnly }) {
  return (dispatch) => {
    dispatch(oldgetMetricsStart(month));
    const params = Object.assign({}, {
      month,
      year,
      newUsersOnly,
    });

    request.get(`${window.Config.API_URL}/business/metrics`).withCredentials().set('X-Request-ID', uuidv4())
      .query(params)
      .then((resp) => {
        dispatch(oldgetMetricsSuccess({ metrics: resp.body }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(oldgetMetricsFail());
      });
  };
}

export function olddownloadMetricsReport({ month, year, newUsersOnly, type }) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const params = Object.assign({}, {
      month,
      year,
      newUsersOnly,
      type,
    });

    window.open(`${window.Config.API_URL}/business/metrics/report?month=${params.month}&year=${params.year}&newUsersOnly=${params.newUsersOnly}&type=${params.type}`).withCredentials().set('X-Request-ID', uuidv4());
  };
}
/* ========= getOutcomeVisualisation API ========= */

const getOutcomeVisualisationStart = () => ({
  type: types.GET_OUTCOME_VISUALISATION_START,
});

const getOutcomeVisualisationSuccess = (data) => ({
  type: types.GET_OUTCOME_VISUALISATION_SUCCESS,
  data,
});

const getOutcomeVisualisationFail = () => ({
  type: types.GET_OUTCOME_VISUALISATION_FAIL,
});

export function getOutcomeVisualisation() {
  return (dispatch) => {
    dispatch(getOutcomeVisualisationStart());
    request
      .get(`${window.Config.API_URL}/business/outcome_visualization`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())

      .then((resp) => {
        if (resp.statusCode === 200) {
          const data = JSON.parse(resp.text);
          dispatch(getOutcomeVisualisationSuccess(data));
        } else {
          dispatch(getOutcomeVisualisationFail());
        }
      })
      .catch((ex) => {
        console.error(ex);
        dispatch(getOutcomeVisualisationFail());
      });
  };
}
